import { gql } from '@apollo/client';

export const GET_ORGANIZATION_BINDER = gql`
  query organizationBinder($organizationId: String!) {
    get(organizationId: $organizationId)
      @rest(type: "Binder", path: "/organization", endpoint: "binder") {
      id
      name
    }
  }
`;

export const GET_ALL_TENDERS = gql`
  query tendersByOrganization {
    tenders: get
      @rest(type: "Tender", path: "/tenders", endpoint: "etendering") {
      endDate
      id
      state
    }
  }
`;

export const GET_ORG_RESOURCES = gql`
  query orgResources($id: String!) {
    resources(id: $id)
      @rest(
        type: "OrgResources"
        path: "/organizations/{args.id}/resourcecounts"
        endpoint: "admin"
      ) {
      projects
      facilities
      tenders
      selections
    }
  }
`;
